import { createReducer } from '@reduxjs/toolkit';
import { UPDATE_PATH } from '../actions/pathActions';

const urlInitial = typeof window !== 'undefined' ? decodeURIComponent(document.baseURI) : '';
export const initialState = {
  url: decodeURIComponent(urlInitial),
};

const canonicalUrl = createReducer(initialState,
  (builder) => {
    builder
      .addCase(UPDATE_PATH, (state, action) => ({ ...state, url: action.url }));
  }
);
export default canonicalUrl;
